import { useAuth } from "@/providers/auth.provider";
import { AuthState } from "@/types/auth.types";
import { createFileRoute, Link, Navigate, Outlet } from "@tanstack/react-router";
import { House } from "lucide-react";

function AuthLayout() {
  const state = useAuth();

  if (state.authState === AuthState.AUTHENTICATED) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <div className='flex relative h-screen w-full overflow-clip bg-[url("/auth/image.png")] bg-cover bg-white backdrop-blur-md items-center justify-center background-filter background-contrast-0 bg-no-repeat'>
      <Link
        to="/"
        className="bg-secondary absolute flex justify-center items-center left-8 top-8 rounded-full p-1 size-12"
      >
        <House className="size-7 " />
      </Link>
      <div className="w-fit bg-blue-50 md:w-1/4 md:min-w-[28rem] p-8 flex items-center justify-center border border-gray-400 saturate-100 backdrop-contrast-100 rounded-xl">
        <Outlet />
      </div>
    </div>
  );
}

export const Route = createFileRoute("/(auth)/__auth")({
  component: AuthLayout,
});
